'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Rate = require('./Rate');

var _Rate2 = _interopRequireDefault(_Rate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Rate2["default"];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-rate/lib/index.js
// module id = 1126
// module chunks = 0